module.exports = __webpack_public_path__ + "src/assets/img/hxjs_jsjg_04@2x.ab55fb50.png";